import { createStore } from 'vuex';
import { breakPoints, loadAsync, pages, products } from './store-utils';
import { jQParam } from '@/util';

const rootClasses = document.documentElement.classList;
let imageExtension = 'jpg';
if (rootClasses.contains('avif')) {
   imageExtension = 'avif';
} else if (rootClasses.contains('webp')) {
   imageExtension = 'webp';
}
let formPageUrl = '/tilbud';
if (document.location.hostname === 'local.findforsikring.dk') {
   formPageUrl = 'http://local-form.findforsikring.dk';
}
export const store = createStore({
   state() {
      return {
         stats: {
            saved: '2.700',
            usedBy: '700.000',
         },
         landingpage: null,
         form_only: false,
         pages: pages,
         // Responsive
         width: 0,
         height: 0,
         indicator: process.env.NODE_ENV !== 'production' || document.location.hostname === 'local.findforsikring.dk',
         // Products
         products: products,
         showAllProducts: false,
         imageExtension,
         wistiaLoaded: false,
         trustpilotLoaded: false,
         allowedCookieCategories: [],
         formPageUrl,
      };
   },
   getters: {
      header: (state) => state.header,
      stats: (state) => state.stats,
      headline: (state) =>
         state.landingpage ? state.landingpage.title : 'Få 3 gratis tilbud og find en billig forsikring.',
      pages: (state) => state.pages,
      formOnly: (state) => state.form_only,
      // Responsive
      width: (state) => state.width,
      small: (state) => state.width < 768,
      height: (state) => state.height,
      breakpoint: (state) => {
         for (const entry of Object.entries(breakPoints)) {
            if (state.width >= entry[1]) {
               return entry[0];
            }
         }
         return null;
      },
      indicator: (state) => state.indicator,
      gte: (state) => (breakpoint) => state.width >= breakPoints[breakpoint],
      lte: (state) => (breakpoint) => {
         const width = state.width;
         const bps = Object.keys(breakPoints);
         const idx = bps.indexOf(breakpoint);
         let next = breakpoint;
         if (idx > 0) {
            next = bps[idx - 1];
         }
         const nextBreakpoint = breakPoints[next];
         return width <= nextBreakpoint;
      },
      containerClass: (state, getters) => (getters.breakpoint === 'xs' ? 'container-fluid' : 'container'),
      // Products

      products: (state) => state.products,
      productCount: (state) =>
         state.products.reduce((result, item) => {
            result += item.count;
            return result;
         }, 0),
      selectedProducts: (state) => state.products.filter((product) => product.count > 0),
      findProductByIcon: (state) => (icon) => state.products.find((product) => product.icon === icon),
      allIdentifiers: (state) => state.products.map((product) => product.icon),
      showAllProducts: (state) => state.showAllProducts,
      formUrl: (state, getters) => {
         if (!getters.productCount) {
            return null;
         }
         const params = {};
         getters.products
            .filter((product) => product.count > 0)
            .forEach((product) => {
               const key = product.icon.split(/\d/)[0];
               if (product.max === 1) {
                  params[key] = 'on';
               } else {
                  for (let n = 1; n <= product.count; n++) {
                     if (n > 1 || product.label === 'Bil') {
                        params[key + n] = 'on';
                        if (key === 'ulykke') {
                           // Also add sundhed
                           params[`sundhed${n}`] = 'on';
                        }
                     } else {
                        params[key] = 'on';
                        if (key === 'ulykke') {
                           // Also add sundhed
                           params.sundhed = 'on';
                        }
                     }
                  }
               }
            });
         return `${state.formPageUrl}/?${jQParam(params)}`;
      },
   },
   mutations: {
      setLandingpage: (state, landingpage) => (state.landingpage = landingpage),
      setHeadline: (state, headline) => (state.headline = headline),
      setFormOnly: (state, only) => (state.form_only = only),
      // Responsive
      updateWidth: (state, width) => (state.width = width),
      updateHeight: (state, height) => (state.height = height),
      // Products
      addProduct: (state, product) => {
         console.log('adding product', product);
         state.products.find((p) => p.icon === product.icon).count++;
      },
      removeProduct: (state, product) => {
         console.log('removing product', product);
         state.products.find((p) => p.icon === product.icon).count--;
      },
      toggleShowAllProducts: (state) => (state.showAllProducts = !state.showAllProducts),
      activateWistia: (state) => {
         if (!state.wistiaLoaded) {
            state.wistiaLoaded = true;
            loadAsync('//fast.wistia.com/assets/external/E-v1.js');
            console.log('Wistia activated', state.allowedCookieCategories);
         }
      },
      activateTrustpilot: (state) => {
         if (!state.trustpilotLoaded) {
            state.trustpilotLoaded = true;
            loadAsync('//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js');
            console.log('Trustpilot activated');
         }
      },
      setAllowedCookieCategories: (state, categories) => {
         state.allowedCookieCategories = categories;
      },
   },
});
